import OrderCargoOrderActiveListRequest from "../../../../api/raily/order/cargo-order/active-list/order-cargo-order-active-list.request";
import OrderCargoOrderActiveListParams from "./order-cargo-order-active-list-params";

const create = (
  params: OrderCargoOrderActiveListParams,
): OrderCargoOrderActiveListRequest => {
  return {
    creationEnd: params.creationDateTo,
    creationStart: params.creationDateFrom,
  };
};

const orderCargoOrderActiveListParamsFactory = {
  create,
};

export default orderCargoOrderActiveListParamsFactory;
